export default "__VITE_ASSET__CiRv5AAA__"